import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'blg-listing-component',
  templateUrl: './listing-component.component.html',
  styleUrls: ['./listing-component.component.scss']
})
export class ListingComponentComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
